import { faStar } from "@jewlr/pro-regular-svg-icons/faStar"
import { faStar as solidStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalfAlt as solidStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalfAlt"
import { Box, Button, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import withReviews from "areas/product/hoc/with-reviews"
import { roundToHalf } from "helpers/round-to-half"

const Reviews = styled(Button).attrs({
  variant: "text",
})`
  font-size: 14px;
  font-weight: 600;
  height: 12px;
  line-height: 12px;
  ${(props) =>
    !props.displayReview &&
    `
    text-decoration: underline;
    &:focus,
    &:hover {
      text-decoration: none;
    }
  `}
  ${(props) => props.theme.mediaQueries.tablet`
    font-size: 12px;
    font-weight: 400;
    text-decoration: none;
  `}
`
const StyledStar = styled(FontAwesomeIcon).attrs((props) => ({
  mr: "2px",
  ...props,
}))``
const StyledReviewCount = styled(Typography).attrs((props) => ({
  as: "span",
  ...props,
}))`
  color: ${(props) => props.theme.colors.black};
  margin-left: 8px;
  ${(props) => props.theme.mediaQueries.tablet`
    color: ${props.theme.colors.primary};
    margin-left: 3px;
  `}
`

/**
 * Ratings/reviews component.
 *
 * @author [Adi Bakija]
 */
const InternalRatings = ({ handleClick, loading, ratings }) => {
  let displayReview = ratings?.average_score >= 4
  if (loading) return <Box minHeight="12px" />

  let starArray = []

  if (displayReview) {
    let average_rating = roundToHalf(ratings.average_score, 0.5)
    for (let i = 1; i <= 5; i++) {
      if (i <= average_rating) {
        starArray.push(
          <StyledStar color={"#F7BF4D"} icon={solidStar} key={i} width={12} />
        )
      } else if (i <= average_rating + 0.5) {
        starArray.push(
          <StyledStar
            color={"#F7BF4D"}
            icon={solidStarHalf}
            key={i}
            width={12}
          />
        )
      } else {
        starArray.push(
          <StyledStar color={"#F7BF4D"} icon={faStar} key={i} width={12} />
        )
      }
    }
  } else {
    for (let i = 1; i <= 5; i++) {
      starArray.push(
        <StyledStar color="grey.300" icon={solidStar} key={i} width={12} />
      )
    }
  }

  return (
    <Reviews
      data-cy="product-rating"
      displayReview={displayReview}
      onClick={handleClick}
    >
      {starArray}
      <StyledReviewCount>
        {displayReview ? `${ratings.total_review} reviews` : "Write a Review"}
      </StyledReviewCount>
    </Reviews>
  )
}

InternalRatings.propTypes = {
  handleClick: PropTypes.func,
  loading: PropTypes.bool,
  ratings: PropTypes.object,
}

export default withReviews(InternalRatings)
